import {
  TipoTenantEnum,
  TenantTipoEstrutura,
  TenantTipoHabitacao,
  TipoEstruturaMoradiaEnum,
} from "core/resources/enums/tenant";
import { EmpresaDetalhe } from "core/resources/types/empresa";
import { InterfaceToType } from "core/resources/types/shared";
import { TipoContatoEnum } from "core/features/auth/typings/user";

export enum TenantStatus {
  Ativo = "e2d477bd-0e21-4d0e-8af4-092ec3cb9360",
  Inativo = "e2d477bd-0e21-4d0e-8af4-092ec3cb9361",
  Bloqueado = "e2d477bd-0e21-4d0e-8af4-092ec3cb9362",
}

export interface TenantPaginateResponse {
  id: string;
  nome: string;
  imagemUrl: string;
  estado: string;
  uf?: string;
  cidade: string;
  tipoTenantId: TipoTenantEnum;
  status: {
    id: string;
    nome: string;
  };
}

interface Endereco {
  cep?: string | null;
  cidade?: string | null;
  estado?: string;
  bairro?: string | null;
  numero?: string | null;
  estadoId?: string | null;
  cidadeId?: string | null;
  logradouro?: string | null;
  complemento?: string | null;
  observacao?: string | null;
}

export interface TenantDetalhe extends EmpresaDetalhe {
  id: string;
  dateCreated?: string;
  status: keyof TenantStatus;
  statusId: TenantStatus;
  tipoEstrutura: TenantTipoEstrutura;
  tipoHabitacao: TenantTipoHabitacao;
  areaConstruida: number;
  tipoEstruturaMoradia?: TipoEstruturaMoradiaEnum;
  quantidadeUnidades?: number;
  tipoTenantId: TipoTenantEnum;
  integradoPagamentoOnline: boolean;
}

export interface TenantUsuarioFormulario {
  dataFimAcesso: string;
  pessoa: {
    nome: string;
    documento?: string;
    rg?: string;
    dataNascimento?: any;
    sexo?: string;
    pis?: string;
    telefone?: string;
    email?: string;
    imagemUrl?: string;
    contatos?: {
      id: string;
      conteudo: string;
      tipoContatoId: TipoContatoEnum;
    }[];
  };
  perfilId: string;
  pessoaId: string;
  tenants: string[];
  // mandatoInicio: string;
  // mandatoFim?: string;
  endereco?: InterfaceToType<Endereco>;
}

export interface TenantUsuarioDetalhe extends TenantUsuarioFormulario {
  id: string;
}

export interface TenantUsuarioItem {
  id: string;
  email: string;
  perfis: {
    id: string;
    nome: string;
  }[];
  pessoa: {
    id: string;
    nome: string;
    documento: string;
    imagemUrl: string;
    dataNascimento: string;
  };
  dataFimAcesso: string | null;
  numeroCondominios: number | null;
}

export interface TenantTreeResponse {
  key: string;
  name: string;
  title: string;
  children: TenantTreeResponse[];
}

export interface TenantIntegracaoFacialResponse {
  id: string;
  nome: string;
  snapshotUrl: string;
  login: string;
  senha: string;
}

export interface TenantIntegracaoResponse {
  protestoBoleto: boolean;
  intelbras: boolean;
  intelbrasFaciais: TenantIntegracaoFacialResponse[];
}
